/**
 * notifications.context.js
 */

import { createContext } from 'react';

const NotificationsContext = createContext({
  notifications: null,
  unreadCount: 0,
  open: false,
  setNotifications: notifications => {},
  setUnreadCount: count => {},
  decrementUnreadCount: () => {},
  setOpen: isOpen => {},
  setMultiple: obj => {}
});

export default NotificationsContext;